import { render, staticRenderFns } from "./ecDatepicker.vue?vue&type=template&id=12ec55cc&lang=pug"
import script from "./ecDatepicker.vue?vue&type=script&lang=ts"
export * from "./ecDatepicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VTextField: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VTextField/VTextField.js').default,VDatePicker: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VDatePicker/VDatePicker.js').default,VDialog: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VDialog/VDialog.js').default})
